export default __webpack_public_path__ + "static/media/ic_settings_24px.77cd8308.svg";